import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ReactNode } from "react";

type ListPageTopBarType = {
  title: string;
  children: ReactNode;
  leftSideComponent?: ReactNode;
};
export const ListPageTopBar = ({
  title,
  children,
  leftSideComponent,
}: ListPageTopBarType) => {
  return (
    <Card className="flex md:items-start justify-between md:flex-row flex-col md:pb-0 pb-3">
      <div className="flex flex-col md:flex-row md:items-center md:gap-3">
        <CardHeader className="md:pt-5 md:pl-4">
          <CardTitle>{title}</CardTitle>
        </CardHeader>

        <div className="flex gap-3 items-center pl-5 md:pl-0 mb-4 md:mb-0">
          {leftSideComponent}
        </div>
      </div>
      <CardContent className="flex items-center h-full py-0 pl-4 gap-4 flex-wrap">
        {children}
      </CardContent>
    </Card>
  );
};
